<template>
    <TemplateBase
        v-if="entry"
        :key="entry.id"
        class="template template--overview"
    >
        <template #hero>
            <BaseHero
                :title="hero?.title ?? entry.title"
                :description="hero.subtitle"
                :cta="hero.cta"
                :footer-text="hero.footer"
            />
        </template>

        <template #default>
            <ContentBlocks v-if="entry?.contentBlocks" :content-blocks="entry.contentBlocks" />

            <NewsletterSignup v-if="entry?.newsletterSignupVisible" />
            <CtaCardsBlock v-if="entry?.ctaCardsVisible" />
        </template>
    </TemplateBase>
</template>

<script setup>
const props = defineProps({
    entry: {
        type: Object,
        default: () => {},
        required: true
    }
});

const hero = computed(() => {
    if (props.entry?.defaultHero?.[0]) {
        return props.entry.defaultHero[0];
    } else if (props.entry?.projectHero?.[0]) {
        return props.entry.projectHero[0];
    }
});
</script>
